import { TextInput } from '@core/components/Inputs';
import { SelectSimple } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import { PessoaFisica, PessoaJuridica } from 'app/main/pessoa';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

const DadosGerais = (props) => {
  const { novoRegistro, visualizar, papel, pessoa, fetchPapel, possuiVinculo } = props;
  const { handleChange, handleBlur, errors, touched } = props;

  const { tipoPessoa = 'JURIDICA', nome } = pessoa;

  const exibirPessoaJuridica = tipoPessoa === 'JURIDICA';
  const exibirPessoaFisica = tipoPessoa === 'FISICA';

  const preenchidoCpf = pessoa.pessoaFisica && pessoa.pessoaFisica.cpf && pessoa.pessoaFisica.cpf.length === 11;
  const preenchidoCnpj = pessoa.pessoaJuridica && pessoa.pessoaJuridica.cnpj && pessoa.pessoaJuridica.cnpj.length === 14;
  const desabilitarTipoPessoa = possuiVinculo;
  const desabilitar = !!novoRegistro && (preenchidoCpf || preenchidoCnpj) && !!pessoa.conta && possuiVinculo;
  const nomeTouched = touched && touched.pessoa && touched.pessoa.nome;
  const nomeError = errors && errors.pessoa && errors.pessoa.nome;

  return (
    <>
      <Grid item xs={12}>
        <TextInput
          required
          autoFocus
          id="pessoa.nome"
          label="Nome"
          fullWidth
          onChange={handleChange}
          value={nome}
          touched={nomeTouched}
          error={nomeError}
          readOnly={visualizar}
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectSimple
          defaultValue="JURIDICA"
          readOnly={visualizar}
          label="Tipo de pessoa"
          id="pessoa.tipoPessoa"
          onChange={(event) => {
            handleChange(event);
            if (event.target.value === 'FISICA') {
              handleChange({ target: { id: 'pessoa.cpfCnpj', value: undefined } });
              handleChange({ target: { id: 'pessoa.pessoaJuridica', value: undefined } });
            } else {
              handleChange({ target: { id: 'pessoa.cpfCnpj', value: undefined } });
              handleChange({ target: { id: 'pessoa.pessoaFisica', value: undefined } });
            }
          }}
          value={tipoPessoa}
          options={[
            { title: 'Pessoa Jurídica', id: 'JURIDICA' },
            { title: 'Pessoa Física', id: 'FISICA' },
          ]}
          disabled={desabilitarTipoPessoa}
        />
      </Grid>

      {exibirPessoaJuridica && (
        <PessoaJuridica
          readOnly={visualizar}
          handleChange={handleChange}
          handleBlur={handleBlur}
          pessoa={pessoa || {}}
          touched={touched}
          errors={errors}
          disabled={desabilitar}
          papel={papel}
          fetchPapel={fetchPapel}
        />
      )}
      {exibirPessoaFisica && (
        <PessoaFisica
          readOnly={visualizar}
          handleChange={handleChange}
          handleBlur={handleBlur}
          pessoa={pessoa || {}}
          touched={touched}
          errors={errors}
          disabled={desabilitar}
          papel={papel}
          fetchPapel={fetchPapel}
        />
      )}
    </>
  );
};

DadosGerais.defaultProps = {
  pessoa: {
    tipoPessoa: 'JURIDICA',
  },
};

const TabDadosGerais = (props) => {
  const formikContext = useFormikContext();

  const { values, handleChange, handleBlur, errors, touched } = formikContext;

  return (
    <DadosGerais
      novoRegistro={values.id}
      visualizar={props.visualizar}
      handleChange={handleChange}
      handleBlur={handleBlur}
      errors={errors}
      touched={touched}
      pessoa={values.pessoa}
      papel={props.papel}
      fetchPapel={props.fetchPapel}
      possuiVinculo={values.possuiVinculo}
    />
  );
};

TabDadosGerais.propTypes = {
  visualizar: PropTypes.bool,
};

export default TabDadosGerais;
